import React, { useState } from "react";
import { Dispatch, SetStateAction } from "react";
import { Category } from "../../types/types";
import CalendarViewToggle, { CalendarViewMode } from "../../components/calendarViewToggle/CalendarViewToggle";
import MyCalendar from "../../components/myCalendar/myCalendar";
import AppointmentsAdvancedView from "./components/AppointmentsAdvancedView/AppointmentsAdvancedView";

interface ICalendarPageProps {
  setActiveCategory?: Dispatch<SetStateAction<Category>>;
}

/**
 * Calendar Page - Client Version
 *
 * Supports both classic (MyCalendar) and advanced calendar views
 * User can toggle between them using the view switcher
 */
const CalendarPage: React.FC<ICalendarPageProps> = ({ setActiveCategory }) => {
  const [viewMode, setViewMode] = useState<CalendarViewMode>('advanced');

  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      {/* View Toggle Buttons */}
      <CalendarViewToggle 
        activeView={viewMode} 
        onViewChange={setViewMode} 
      />

      {/* Render appropriate view based on selection */}
      {viewMode === 'classic' && setActiveCategory && (
        <MyCalendar setActiveCategory={setActiveCategory} />
      )}
      {viewMode === 'advanced' && (
        <AppointmentsAdvancedView />
      )}
    </div>
  );
};

export default CalendarPage;
